import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import CourseSelection from './components/CourseSelection';
import AlmaDashboard from './components/AlmaDashboard';

function App() {
  return (
    <Router>
      <NotificationProvider>
        <AuthProvider>
          <Routes>
            {/* Route pubbliche */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            {/* Route protette */}
            <Route
              path="/corsi"
              element={
                <ProtectedRoute>
                  <CourseSelection />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/corsi" replace />} />
            <Route
              path="/dashboard/:courseId"
              element={
                <ProtectedRoute>
                  <AlmaDashboard />
                </ProtectedRoute>
              }
            />

            {/* Redirect per route non trovate */}
            <Route path="*" element={<Navigate to="/corsi" replace />} />
          </Routes>
        </AuthProvider>
      </NotificationProvider>
    </Router>
  );
}

export default App;
